const StudentPromotion = () => {
    return (
        <div className="bg-gray-200">
            <div className="p-8">
                <h1>Students</h1>
                <span className="flex space-x-4">
                    <h3>Home &gt;</h3>
                    <h3 className="text-yellow-600">Student Promotion</h3>
                </span>
            </div>
            <div className="bg-white mx-4 mt-8 p-8 ">
                <span className="flex justify-between px-4 mb-4">
                    <h2 className="text-xl font-semibold">Search Student Promotion</h2>
                    <h2>...</h2>
                </span>
                <form className=" md:flex md:justify-between text-gray-700 flex flex-col ">
                    <span className="my-2 mt-4 pb-4" >
                        <label className="pb-2" htmlFor="CS">Current Session</label>
                        <select className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                            <option>2017-2018</option>
                            <option>2018-2019</option>
                            <option>2015-2016</option>
                            <option>2014-2015</option>
                        </select>
                    </span>
                    <span className="pb-4">
                        <label className="pb-2"> Promote session</label>
                        <select className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                            <option>2017-2018</option>
                            <option>2018-2019</option>
                            <option>2015-2016</option>
                            <option>2014-2015</option>
                        </select>
                    </span>

                    <span className="pb-4">
                        <label className="pb-2"> Promotion From Class</label>
                        <select className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                            <option>Play</option>
                            <option>Nursery</option>
                            <option>1</option>
                            <option>2</option>
                        </select>
                    </span>


                    <span className="pb-4">
                        <label className="pb-2"> Promotion To Class</label>
                        <select className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                            <option>Play</option>
                            <option>Nursery</option>
                            <option>1</option>
                            <option>2</option>
                        </select>
                    </span>


                </form>
                <div className="flex space-x-8 mt-12">
                    <button className="px-6 py-3 bg-yellow-500 text-white" >Save</button>
                    <button className="px-6 py-3 bg-blue-950 text-white" >Reset</button>
                </div>
            </div>


        </div>
    );
}

export default StudentPromotion;